import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { base64urlEncode } from "./Base64URL";

function RiskAnalyzerlandingsignUp() {
  const navigate = useNavigate();

  const [isHuman, setIsHuman] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const [error, setError] = useState("");

  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{10}$/; // Adjust this regex for your specific mobile number format
    return regex.test(number);
  };

  const handleSignup = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!username && !email) {
      setError("Full Name and Email are required.");
      return;
    }
   
    setError(""); // Clear error if validation passes
    navigate(`/RiskAnalyzerCalculate/${base64urlEncode(email)}/${base64urlEncode(username)}`);

  };

  return (
    <>
      <div className="form-main-conatiner risk-aly">
        <h2>Please give your name and email to start</h2>
        <form onSubmit={handleSignup}>
          <div className="input-div">
            <label>
              Full Name <span>*</span>
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-div">
            <label>
              Email <span>*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          <div className="btn-sec">
            <button type="submit" className="btnstart">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default RiskAnalyzerlandingsignUp;
